import styled from 'styled-components';
import {
  variant, layout, typography, color, compose, space
} from 'styled-system';

const Button = styled.button`
  appearance: none;
  font-size: 1rem;
  font-family: inherit;
  padding: 11px 15px;
  cursor: pointer;
  border-radius: 3px;  // Round edges
  border: none;
  &:hover {opacity: 0.7};
  background-color: ${(props) => props.theme.colors.primary};
  ${(props) =>
  variant({
    prop: 'variant',
    variants: {
      solid: {
        color: 'black',
        backgroundColor: props.backgroundColor,
      },
      outlined: {
        backgroundColor: 'transparent',
        borderColor: props.backgroundColor,
        color: props.backgroundColor,
        borderWidth: '2px',
        borderStyle: 'solid'
      },
      text: {
        backgroundColor: 'transparent',
        border: 'none',
        color: props.theme.colors.primary,
      }
    },
  })}
  
  ${compose(layout, color, typography, space)}
`;

Button.defaultProps = {
  variant: 'solid',
};

export default Button;